






















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ProjectModel } from "../models";

const pStore = namespace("projects");
const snackStore = namespace("snackbar");

@Component
export default class SubscriptionInfo extends Vue {
  @pStore.Getter activeSubscriptions!: ProjectModel;

  @pStore.Action fetchSubscriptions!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  headers = [
    { text: "Projectnummer", value: "id", sortable: false },
    { text: "Omschrijving", value: "description", sortable: false }
  ];

  pagination = {
    descending: true
  };

  mounted() {
    this.fetchSubscriptions().catch(() => {
      this.defaultError();
    });
  }
}
